import { apiFetch, IApiQuerySingularResponse, typedApiFetch } from '../../utils';
import { dispatch } from '../../store';
import { invoicePreviewReceived, setInvoiceGroupSaveState, setLoadedState } from './invoiceManagementSlice';
import { REACT_APP_API_ROOT_URI } from '../../../App';
import { TInvoiceGroupCommand } from 'src/components/pages/InvoiceGroups/zodSchemas';
import { IInvoiceGroups } from '@llws/lift-entity-interfaces';
import { showMessage } from 'src/redux/features/messaging/actions';

export const loadInvoiceManagementPreview = async (
  freshbooksClientId: number,
  year?: number,
  month?: number,
) => {
  dispatch(setLoadedState('loading'));

  const queryParams = new URLSearchParams({
    ...(year && { year: year.toString() }),
    ...(month && { month: month.toString() }),
  });

  const url = `${REACT_APP_API_ROOT_URI}/invoice_management/client/${freshbooksClientId}/preview?${queryParams}`;

  try {
    const response = await apiFetch(url);
    const responseData = await response.json();

    if (response.ok) {
      dispatch(invoicePreviewReceived(responseData));
    } else {
      console.error('Failed to load invoice preview:', responseData);
      dispatch(setLoadedState('error'));
    }
  } catch (error) {
    console.error('Error fetching invoice preview:', error);
    dispatch(setLoadedState('error'));
  }
};

export const saveInvoiceGroup = async (
  invoiceGroupCommandPayload: TInvoiceGroupCommand,
  accountId: number,
) => {
  dispatch(setInvoiceGroupSaveState('saving'));

  const url = `${REACT_APP_API_ROOT_URI}/invoice_management/client/${accountId}`;

  try {
    const response = await typedApiFetch<IApiQuerySingularResponse<IInvoiceGroups>>(url, {
      method: 'POST',
      body: JSON.stringify(invoiceGroupCommandPayload),
    });
    const responseData = await response.json();

    if (response.ok) {
      showMessage({
        message: 'All changes to invoice groups have been saved successfully.',
        severity: 'success',
      });
      dispatch(setInvoiceGroupSaveState('saved'));
      return true;
    } else {
      showMessage({
        message: 'Failed to save invoice groups.',
        severity: 'error',
      });
      dispatch(setInvoiceGroupSaveState('error'));
      return false;
    }
  } catch (error) {
    showMessage({
      message: 'Encountered an error while saving invoice groups.',
      severity: 'error',
    });
    dispatch(setInvoiceGroupSaveState('error'));
    return false;
  }
};
